/**
 * OrderStatusBadge Component
 *
 * Reusable badge for displaying order status
 * Supports all order statuses with color coding
 */

'use client';

import { useTranslations } from 'next-intl';
import { cn } from '@/src/shared/lib/utils';

interface OrderStatusBadgeProps {
  status: 'DRAFT' | 'PUBLISHED' | 'ASSIGNED' | 'IN_PROGRESS' | 'PENDING_REVIEW' | 'COMPLETED' | 'CANCELLED' | 'DISPUTED' | 'ARCHIVED';
  className?: string;
}

export function OrderStatusBadge({ status, className }: OrderStatusBadgeProps) {
  const t = useTranslations('profile.orders.status');

  const colors = {
    DRAFT: 'bg-gray-100 text-gray-700',
    PUBLISHED: 'bg-blue-100 text-blue-700',
    ASSIGNED: 'bg-purple-100 text-purple-700',
    IN_PROGRESS: 'bg-yellow-100 text-yellow-700',
    PENDING_REVIEW: 'bg-orange-100 text-orange-700',
    COMPLETED: 'bg-green-100 text-green-700',
    CANCELLED: 'bg-red-100 text-red-700',
    DISPUTED: 'bg-red-100 text-red-700',
    ARCHIVED: 'bg-gray-200 text-gray-600',
  };

  return (
    <span
      className={cn(
        'px-2 py-1 rounded-full text-xs font-medium',
        colors[status] || colors.DRAFT,
        className
      )}
    >
      {t(status.toLowerCase())}
    </span>
  );
}
